// extracted by mini-css-extract-plugin
export default {"root":"KPITypeSelect_root__CJF0g"};